import { isIntersection } from './helpers';
import { USER_PERMISSIONS, USER_TYPES } from './enums';

export const isSuperManager = (user) => {
  return isIntersection(user.types, [USER_TYPES.superManager]);
};

export const isManager = (user) => {
  return isIntersection(user.types, [USER_TYPES.manager]);
};

export const isTrainer = (user) => {
  return isIntersection(user.types, [USER_TYPES.trainer]);
};

export const hasPermEditAthlete = (user) => {
  return isIntersection(user.permissions, [USER_PERMISSIONS.write_athletes]);
};

export const hasPermViewContributions = (user) => {
  return isIntersection(user.permissions, [
    USER_PERMISSIONS.read_contributions,
  ]);
};

export const canChangeTrainerForAthlete = (user) => {
  return (
    user.isAdmin ||
    isSuperManager(user) ||
    (isManager(user) && hasPermEditAthlete(user))
  );
};

export const canViewContributions = (user) => {
  return user.isAdmin || isSuperManager(user) || hasPermViewContributions(user);
};

export const hasPermViewDankai = (user) => {
  return isIntersection(user.permissions, [USER_PERMISSIONS.read_dankai]);
};

export const hasPermEditDankai = (user) => {
  return isIntersection(user.permissions, [USER_PERMISSIONS.write_dankai]);
};

export const canViewDankai = (user) => {
  return user.isAdmin || isSuperManager(user) || hasPermViewDankai(user);
};

export const canEditDankai = (user) => {
  return user.isAdmin || isSuperManager(user) || hasPermEditDankai(user);
};
